//@ts-nocheck
import * as React from 'react'
import Svg, { Defs, LinearGradient, Stop, Text, TSpan } from 'react-native-svg'

import { translate } from '../../i18n'

type linearTextProps = {
  txt: string
}

/**
 * <LinearGradient />, <Text /> and <TSpan /> have no child as per it's type file
 * For time being , disabled the type check for entire file
 */
export const LinearText = ({ txt }: linearTextProps) => {
  if (!txt) return null
  return (
    <Svg viewBox="0 0 280 31" height="31" width="100%">
      <Defs>
        <LinearGradient
          id="rainbow"
          x1="0"
          x2="0"
          y1="0"
          y2="100%"
          gradientUnits="userSpaceOnUse"
          gradientTransform={undefined}
        >
          <Stop stopColor="#5D2CB0" offset="0%" />
          <Stop stopColor="#9444FB" offset="100%" />
        </LinearGradient>
      </Defs>
      <Text fill="url(#rainbow)">
        <TSpan fontWeight="900" fontSize="26" x="50%" y="24" textAnchor="middle">
          {translate(txt)}
        </TSpan>
      </Text>
    </Svg>
  )
}
